(() => {
  const selector = '[data-product-recommendations]';

  const loadRecommendations = async (container) => {
    if (!container.dataset.url || container.dataset.loaded === 'true') return;
    container.dataset.loaded = 'true';

    try {
      const response = await fetch(container.dataset.url, {
        headers: { Accept: 'text/html' },
      });
      if (!response.ok) return;

      const documentFragment = new DOMParser().parseFromString(
        await response.text(),
        'text/html',
      );
      const source = documentFragment.querySelector(selector);
      if (!source?.querySelector('.product-card')) return;

      container.innerHTML = source.innerHTML;
      container.setAttribute('aria-busy', 'false');
      container
        .closest('[data-product-recommendations-section]')
        ?.removeAttribute('hidden');
    } catch {
      container.setAttribute('aria-busy', 'false');
    }
  };

  const initialize = (scope = document) => {
    const containers = scope.matches?.(selector)
      ? [scope]
      : [...scope.querySelectorAll(selector)];
    containers.forEach((container) => loadRecommendations(container));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
